import React from 'react';
import './GeneralParkingInfoCSS.css';
import Card from '../../../common/card/card';
import {createElementFromHTML} from '../../../../helpers/helpers'


export default class GeneralParkingInfoComponent extends React.Component {
    constructor(props) {
        super(props);
        const isSpanish = window.location.pathname.slice(0, 4) === '/es' || window.location.pathname.slice(0, 4) === '/es/';
        this.state = {r: null, l: null, isSpanish};

        fetch(`/api/default/listitems?$filter=ParentId%20eq%2043a2fea0-0c49-6a75-a385-ff1400f4265d&$orderby=Ordinal&sf_culture=${this.state.isSpanish ? 'es' : 'en'}`)
            .then((req) => req.json())
            .then(items => items.value)
            .then(items => items.map(i => {
                const tempElements = createElementFromHTML(i.Content);
                return {elem: tempElements, title: i.Title}
            })).then(items => {
            return items.map(t => {
                let r = [];
                const length = t.elem.length;
                let p = [];
                for (let i = 0; i < length; i++) {
                    let inElem = t.elem[i];
                    if (i === length - 1) {
                        let a = this.findAchor(inElem);
                        if (a === null) p.push(inElem.outerHTML);
                        r.push(<Card className={"col-12 p-1"} title={t.title} key={t.title}
                                     buttonText={a === null ? a : a.innerText}
                                     onClickHandler={() => a === null ? null : window.location = a.href}>
                            {p.map((inText, idx) => <div key={t.title + idx}
                                                         dangerouslySetInnerHTML={{__html: inText}}/>)}
                        </Card>)

                    } else {
                        p.push(inElem.outerHTML);
                    }
                }

                return r;
            });

        }).then(r => {
            let isEven = (r.length % 2) === 0;
            let rHalfLength = r.length / 2;
            if (isEven) {
                this.setState(Object.assign(this.state, {r: r.slice(0, rHalfLength), l: r.slice(rHalfLength, r.length)}))
            } else {
                this.setState(Object.assign(this.state, {r: r.slice(0, rHalfLength+1), l: r.slice(rHalfLength+1, r.length)}))

            }
        }).catch(e => console.log(e))
    }

    findAchor = (elem) => {
        if (elem.childNodes.length === 0) {
            return null
        }
        if (elem.childNodes[0].nodeName.toUpperCase() === 'A') {
            return elem.childNodes[0]
        }
        return this.findAchor(elem.childNodes[0]);
    };

    render() {
        return (
            <div className={"row"}>
                <div className={"col-12 px-1"}>
                    <img alt={""} className={"d-md-none img-fluid mt-2 p-0 w-100"}
                         src={this.state.isSpanish ? "/images/default-source/siteimages/component-images/parking-transportation-mobile-header-image807affa00c496a75a385ff1400f4265d.jpg" : "/images/default-source/siteimages/component-images/parkingtransportationmobileimage.jpg"}/>
                    <img alt={""} className={" d-none d-md-block img-fluid mt-2 p-0 w-100"}
                         src={this.state.isSpanish ? "/images/default-source/siteimages/component-images/parking-transportation-header-image5d7affa00c496a75a385ff1400f4265d.jpg" : "/images/default-source/siteimages/component-images/parkingtransportationheader.jpg"}/>
                </div>
                <div className={"col-12 col-md-6 p-0 mt-1"}>
                    {this.state.r === null ? null : this.state.r.map(item => item)}

                </div>
                <div className={"col-12 col-md-6 p-0 mt-1"}>
                    {this.state.l === null ? null : this.state.l.map(item => item)}

                </div>
            </div>
        )
    }
}
